import * as React from "react";
import { AlbumChart } from "./charts/AlbumChart";
import { CategoryChart } from "./charts/CategoryChart";
import { GenreChart } from "./charts/GenreChart";
import { RemixChart } from "./charts/RemixChart";
import { DownloadedFromChart } from "./charts/DownloadedFromChart";
import { BPMGroupChart } from "./charts/BPMGroupChart";
import { KeyChart } from "./charts/KeyChart";
import { LocationChart } from "./charts/LocationChart";
import { DJTypeChart } from "./charts/DJTypeChart";
import { LabelChart } from "./charts/LabelChart";
import { Field, QueryProvider } from "../../../components/context/query";
import { PlatformRenderer } from "../../../utils/platformSelect";
import { SubGenreChart } from "./charts/SubGenreChart";
import { Environment } from "env";
import { generateDS } from "utils/datasource";
import { RemixerChart } from "./charts/RemixerChart";
import { UtilizationChart } from "./charts/UtilizationChart";

interface DownloadState {

}

const allowedFields: Field[] = [{
    dataField: 'label',
    caption: 'Label',
    dataType: 'string'
}, {
    dataField: 'sub_label',
    caption: 'Sublabel',
    dataType: 'string'
}, {
    dataField: 'name',
    caption: 'Album Name',
    dataType: 'string'
}, {
    dataField: 'artist',
    dataType: 'string'
}, {
    dataField: 'bpm',
    caption: 'BPM',
    dataType: 'number'
}, {
    dataField: 'key',
    dataType: 'string'
}, {
    dataField: 'genre_name',
    caption: 'Genre Name',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: generateDS(Environment.DOWNLOAD_API_URL, '/genres', 'id', true), valueExpr: 'name', displayExpr: 'name' }
}, {
    dataField: 'category_name',
    caption: 'Category Name',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: generateDS(Environment.DOWNLOAD_API_URL, '/categories', 'id', true), valueExpr: 'name', displayExpr: 'name' }
}, {
    dataField: 'tag_name',
    caption: 'Version',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: generateDS(Environment.DOWNLOAD_API_URL, '/versions', 'id', true), valueExpr: 'name', displayExpr: 'name' }
}, {
    dataField: 'intro_editor',
    caption: 'Intro Editor',
    dataType: 'string'
}, {
    dataField: 'remixer',
    caption: 'Remixer',
    dataType: 'string'
}, {
    dataField: 'country',
    caption: 'Country',
    dataType: 'string'
},
{
    dataField: 'city',
    caption: 'City',
    dataType: 'string'
},
{
    dataField: 'membership',
    name: 'has_membership',
    editorOptions: { opened: true },
    caption: 'Has Membership',
    dataType: 'boolean',
    filterOperations: ["="]
},
{
    dataField: 'membership',
    caption: 'Subscription Plan',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: ['standard', 'premium'] }
},
{
    dataField: 'membership_library',
    caption: 'Subscription Library',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: [{ val: 'all', label: 'All' }, { val: 'music', label: 'Open Format' }, { val: 'latin', label: 'Latino' }], displayExpr: 'label', valueExpr: 'val' }
},
{
    dataField: 'dj_type',
    caption: 'DJ Type',
    dataType: 'string'
}]
export class Downloads extends React.Component<{}, DownloadState> {
    render() {
        return <div className="dashboard">
            <div className='charts'>
                <QueryProvider fields={allowedFields}>{({ filter }) => {
                    return <div className='bpm-container'>
                        <div className='row'>
                            <div className='col'>
                                {filter}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <AlbumChart />
                            </div>
                        </div>
                        <PlatformRenderer only={['supreme']}>
                            <div className='row'>
                                <div className='col'>
                                    <RemixerChart />
                                </div>
                            </div>
                        </PlatformRenderer>
                        <PlatformRenderer only={['supreme']}>
                            <div className='row'>
                                <div className='col'>
                                    <UtilizationChart />
                                </div>
                            </div>
                        </PlatformRenderer>
                        <div className='row'>
                            <PlatformRenderer only={['supreme']}>
                                <div className='col'>
                                    <CategoryChart />
                                </div>
                            </PlatformRenderer>
                            <div className='col'>
                                <GenreChart />
                            </div>
                            <PlatformRenderer only={'create'}>
                                <div className='col'>
                                    <SubGenreChart />
                                </div>
                            </PlatformRenderer>
                        </div>
                        <div className='row'>
                            <PlatformRenderer only={['supreme']}>
                                <div className='col'>
                                    <RemixChart />
                                </div>
                            </PlatformRenderer>
                            <div className='col'>
                                <DJTypeChart />
                            </div>
                            <div className='col' style={{ flex: 2 }}>
                                <DownloadedFromChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <BPMGroupChart />
                            </div>
                            <div className='col'>
                                <KeyChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <LocationChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <LabelChart />
                            </div>
                        </div>
                    </div>
                }}</QueryProvider>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/Downloads.tsx